module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-broker-avatar-box"
  }, [_c('div', {
    staticClass: "component-broker-avatar",
    style: ({
      width: (_vm.width + "px"),
      height: (_vm.width + "px"),
      border: _vm.star == 5 ? '2px solid #FFC904' : 'none'
    })
  }, [(_vm.star == 5) ? _c('img', {
    style: ("position: absolute;top: -29%;right: -2%;width: 60%;"),
    attrs: {
      "src": require("../../assets/images/star-5.png")
    }
  }) : _vm._e(), _vm._v(" "), _c('el-image', {
    staticClass: "component-broker-avatar-inner",
    style: (("position: absolute;top: 50%;left: 50%;width: " + _vm.innerWidth + "px; height: " + _vm.innerHeight + "px; margin-top: -" + (_vm.innerHeight/2) + "px; margin-left: -" + (_vm.innerWidth/2) + "px")),
    attrs: {
      "src": _vm.url,
      "fit": "fill"
    }
  })], 1), _vm._v(" "), (_vm.star && _vm.star >= 0) ? _c('div', {
    staticClass: "component-broker-avatar-star"
  }, [_vm._l((parseInt(_vm.star)), function(num) {
    return [_c('img', {
      key: num,
      style: ({
        width: ((_vm.width/6) + "px")
      }),
      attrs: {
        "src": require("../../assets/images/star-full.png"),
        "alt": ""
      }
    })]
  }), _vm._v(" "), (_vm.star > parseInt(_vm.star)) ? [_c('img', {
    style: ({
      width: ((_vm.width/6) + "px")
    }),
    attrs: {
      "src": require("../../assets/images/star-half.png"),
      "alt": ""
    }
  })] : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac657a2e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/agent/avatar.vue
// module id = 657
// module chunks = 1